export const applyVoucher = (initialValue, voucher) => {
  const { value, type } = voucher;

  if (type === 'euro') {
    // Il voucher è di tipo 'euro', sconto fisso in euro
    return Math.max(initialValue - value, 0); // Assicurati che il valore scontato non sia negativo
  } else if (type === 'percentage') {
    // Il voucher è di tipo 'percentage', sconto percentuale
    const discountAmount = (value / 100) * initialValue;
    return Math.max(initialValue - discountAmount, 0); // Assicurati che il valore scontato non sia negativo
  }
};

export const voucherToString = (initialValue, voucher) => {
  const { value, type } = voucher;
  if (type === 'euro') {
    return `${initialValue}€ - ${value}€ = ${applyVoucher(initialValue, voucher).toFixed(2)}€`;
  } else if (type === 'percentage') {
    return `${initialValue}€ - ${value}% = ${applyVoucher(initialValue, voucher).toFixed(2)}€`;
  }
};
